import type { FC } from 'react';
import { CollectionsWrapper } from './Collections.styled';
import collections from './../../../resources/content/collections.png';

interface CollectionsProps { }

const Collections: FC<CollectionsProps> = () => (
   <CollectionsWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Collection</h1>
      </header>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">Java Collection&nbsp;means a single unit of objects.&nbsp;In other words, the java collection&nbsp;framework provides many classes and interfaces. For instance java.util.Collection, java.util.Map, etc. In addition to this, the following are few interfaces :</p>
         <ul className="text-align-justify">
            <li>The Iterable interface is the one that acts as the root interface for all collection classes.</li>
            <li>The collection interface is the one that builds the foundation on which the collection framework depends.</li>
            <li>The Map interface allows us to store data in key-value pairs. </li>
         </ul>
         <p  className="text-align-justify">In addition, collection offers following advantages :</p>
         <ul  className="text-align-justify">
            <li>Consistent and reusable classes/API.</li>
            <li>Better performance as less development time.</li>
            <li>Clean and efficient code.</li>
         </ul>
         <p  className="text-align-justify">The collection framework, therefore, helps reduce designing efforts and increases performance. Below is the hierarchy of collection framework : </p>
         <br/>
         <div>
          <figure className="aligncenter size-large">
            <img decoding="async" width="641" height="408" src={collections} alt="" className="lazy-loaded" sizes="auto, (max-width: 641px) 100vw, 641px" />
          </figure>
        </div>
      </div>
   </CollectionsWrapper>
);

export default Collections;
